import React from 'react';
import {observer} from 'mobx-react';
import filtersStore, {FrameType} from './filters-store';
import PriceRangeSlider from '../price-range/price-range-slider';
import storePageDataSource from '../../storepage-datasource';

declare var __portal: IPortalSettings;

function closeFilters() {
    const menu = document.getElementById('store-filters-container') as HTMLElement;
    menu.style.display = 'none';
    menu.classList.remove('filters-visible');
}

const Filters = observer(() => {
    const isBestSellersPage = window.location.pathname.includes('best-sellers');

    return (
        <div id="store-filters-container">
            <div id="store-filters-x">
                <i
                    className="fas fa-times"
                    onClick={closeFilters}
                    role="button"
                    aria-label="Close Filter Menu"
                ></i>
            </div>
            <div id="sort-by-container">
                <label htmlFor="sort-by">
                    <strong>Sort by</strong>
                </label>
                <select
                    aria-label="Sort By"
                    name="sort-by"
                    id="sort-by"
                    className="form-select d-inline-block"
                    onChange={e => filtersStore.updateFilter('sort', e.target.value)}
                >
                    <option
                        value="0"
                        selected
                    >
                        Featured
                    </option>
                    <option value="1">Price: Low to High</option>
                    <option value="2">Price: High to Low</option>
                    <option value="3">Best Selling</option>
                    {__portal.PortalID !== 3 && <option value="4">Best Reviews</option>}
                    {__portal.PortalID !== 3 && <option value="5">Fast Shipping</option>}
                </select>
            </div>

            <hr />

            <div id="price-range-container">
                <PriceRangeSlider />
            </div>

            <hr />

            <div id="search-school-container">
                <div>
                    {__portal.PortalID < 1 && <strong>Search for your school</strong>}
                    {__portal.PortalID === 1 && <strong>Search for your organization</strong>}
                    {__portal.PortalID === 2 && <strong>Search for your Military Force</strong>}
                    {__portal.PortalID === 3 && <strong>Search for your school/state</strong>}
                </div>

                <input
                    id="school-search"
                    className="form-control d-inline-block"
                    onChange={e => filtersStore.onSchoolSearch(e.target.value)}
                    aria-label={`Search for your ${__portal.PortalID < 1 ? 'school' : __portal.PortalID === 1 ? 'organization' : __portal.PortalID ? 'Military Force' : 'school'}`}
                />
                <div id="store-filters-apply">
                    <span
                        onClick={closeFilters}
                        role="button"
                        aria-label="Close Filter Menu"
                    >
                        Apply Filter
                    </span>
                </div>
            </div>

            <hr />

            <div id="mouldings-container">
                <div>
                    <strong>Moulding Options</strong>
                </div>
                <div className="filters-scrollable">
                    {storePageDataSource.mouldingOptions.map(moulding => (
                        <label key={moulding}>
                            <input
                                className="filter-moulding"
                                type="checkbox"
                                value={moulding}
                                checked={filtersStore.selectedFinish.includes(moulding)}
                                onChange={e => filtersStore.finishChanged(e.target.checked, e.target.value)}
                            />
                            {moulding || 'All Mouldings'}
                        </label>
                    ))}
                </div>
            </div>

            <hr />

            {!isBestSellersPage && (
                <div id="mats-container">
                    <div>
                        <strong>Mat Options</strong>
                    </div>
                    <div className="filters-scrollable">
                        {storePageDataSource.matOptions.map(mat => (
                            <label key={mat}>
                                <input
                                    className="filter-mat"
                                    type="checkbox"
                                    value={mat}
                                    checked={filtersStore.selectedMatCombo.includes(mat)}
                                    onChange={e => filtersStore.matComboChanged(e.target.checked, e.target.value)}
                                />
                                {mat || 'All Mats'}
                            </label>
                        ))}
                    </div>
                </div>
            )}

            {__portal.PortalID === 3 && (
                <>
                    <hr />
                    <div id="frame-type-container">
                        <div>
                            <strong>Frame Type</strong>
                        </div>
                        <div className="filters-scrollable">
                            <label>
                                <input
                                    className="filter-frame-type"
                                    type="checkbox"
                                    value="tassel"
                                    checked={filtersStore.selectedFrameType.includes(FrameType.Tassel)}
                                    onChange={e => filtersStore.frameTypeChanged(e.target.checked, e.target.value as FrameType)}
                                />
                                Tassel Frame
                            </label>
                            <label>
                                <input
                                    className="filter-frame-type"
                                    type="checkbox"
                                    value="diploma"
                                    checked={filtersStore.selectedFrameType.includes(FrameType.Diploma)}
                                    onChange={e => filtersStore.frameTypeChanged(e.target.checked, e.target.value as FrameType)}
                                />
                                Diploma Frame
                            </label>
                            <label>
                                <input
                                    className="filter-frame-type"
                                    type="checkbox"
                                    value="certificate"
                                    checked={filtersStore.selectedFrameType.includes(FrameType.Certificate)}
                                    onChange={e => filtersStore.frameTypeChanged(e.target.checked, e.target.value as FrameType)}
                                />
                                Certificate Frame
                            </label>
                        </div>
                    </div>

                    <hr />
                    <div id="graduation-year-container">
                        <div>
                            <strong>Graduation Year</strong>
                        </div>
                        <input
                            id="graduation-year-search"
                            className="form-control d-inline-block"
                            placeholder="Enter graduation year"
                            type="number"
                            value={filtersStore.selectedGraduationYear}
                            onChange={e => filtersStore.graduationYearChanged(e.target.value)}
                        />
                        {filtersStore.graduationYearError && (
                            <div
                                className="text-danger mt-1"
                                style={{fontSize: 13}}
                            >
                                {filtersStore.graduationYearError}
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
});

export default Filters;
